import { HubtypeUser } from 'models/hubtype-user'

import { createReducer, on } from '@ngrx/store'
import { JsonConvert, ValueCheckingMode } from 'json2typescript'
import * as UserActions from '../actions/user'
import {
  addObjectToList,
  deleteObjectFromList,
  updateObjectInList,
} from '../utils/array-utils'

const jsonConverter: JsonConvert = new JsonConvert()
jsonConverter.valueCheckingMode = ValueCheckingMode.ALLOW_NULL

export type UsersState = HubtypeUser[]
export const initialState: UsersState = []

export const reducer = createReducer(
  initialState,
  on(UserActions.setUsers, (state, { users }) => users),
  on(UserActions.addUser, (state, { user }) =>
    addObjectToList<HubtypeUser>(
      state,
      jsonConverter.deserializeObject(user, HubtypeUser)
    )
  ),
  on(UserActions.updateUser, (state, { user }) =>
    updateObjectInList<HubtypeUser>(
      state,
      jsonConverter.deserializeObject(user, HubtypeUser)
    )
  ),
  on(UserActions.deleteUser, (state, { userId }) =>
    deleteObjectFromList<HubtypeUser>(state, userId)
  )
)
